jQuery(function($) {
  if($('.okeReviews-widget-holder').find('.okeReviews-reviewsWidget-reviewsAggregate.js-okeReviews-reviewsAggregateContainer').length > 0) {
    $('.okeReviews-widget-holder').show();
  }

  var productHeader = setInterval(function () {
    var product_header = jQuery('.product-header .h4.product-header__title');
    if (product_header.length > 0) {
        $('.template-product .section-header--related-product h2.section-header__title').show();
        clearInterval(productHeader);
    }
  }, 300);

  $(document).ready(function() {
    var modal_active = setInterval(function () {
      if ($('#board-customizer-selector.modal--active').length > 0 && $('.dbClick').length > 0) {
        if (!$('#board-customizer-selector.modal--active .boost-pfs-filter-tree-content').length) {
          $('#board-customizer-selector.modal--active button.modal__button').click()
          if ($('.board-customizer-components__item-add.dbClick').length > 0) {
            $('.board-customizer-components__item-add.dbClick').click()
          } else {
            $('.dbClick').parent().find('.board-customizer-components__item-add').click()
          }
        }
        clearInterval(modal_active);
      }
    }, 300);
  })
})